export default __webpack_public_path__ + "static/media/kingabs.cc899a55.PNG";